// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3jZw9","validationTips":"StatementDescriptor_validationTips__1LPJ9"};